import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const NoticePopup: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // 페이지 로드 시 팝업 표시
    setIsOpen(true);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <>
      {/* 배경 오버레이 */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={handleClose}
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      >
        {/* 팝업 컨텐츠 */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          transition={{ duration: 0.3 }}
          onClick={(e) => e.stopPropagation()}
          className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 md:p-8 relative max-h-[90vh] overflow-y-auto"
        >
          {/* 닫기 버튼 */}
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="닫기"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          {/* 헤더 */}
          <div className="text-center mb-6">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
              안녕하세요, 이노페이입니다
            </h2>
            <p className="text-gray-600">
              저희 서비스를 이용해주셔서 감사합니다.
            </p>
          </div>

          {/* 안내 사항 */}
          <div className="space-y-4 mb-6">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-0.5">
                <span className="text-blue-600 font-semibold text-sm">1</span>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">안전한 이용</p>
                <p className="text-gray-600 text-sm">
                  서비스 이용 시 신용카드와 관련된 법적 책임을 숙지하고 이용해
                  주세요.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-0.5">
                <span className="text-green-600 font-semibold text-sm">2</span>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">
                  개인정보 보호
                </p>
                <p className="text-gray-600 text-sm">
                  고객님의 개인정보는 철저히 보호됩니다.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-6 h-6 bg-red-100 rounded-full flex items-center justify-center mr-3 mt-0.5">
                <span className="text-red-600 font-semibold text-sm">3</span>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">
                  불법 행위 금지
                </p>
                <p className="text-gray-600 text-sm">
                  불법적인 용도로 서비스를 이용할 경우 법적 책임이 따릅니다.
                </p>
              </div>
            </div>
          </div>

          {/* 고객센터 */}
          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <p className="text-gray-700 text-sm mb-2">
              문의사항이 있으시면 고객센터로 상담부탁드립니다.
            </p>
            <a
              href="tel:010-9733-3651"
              className="inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold transition-colors"
            >
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              010-9733-3651
            </a>
          </div>

          {/* 확인 버튼 */}
          <button
            onClick={handleClose}
            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
          >
            확인
          </button>
        </motion.div>
      </motion.div>
    </>
  );
};

export default NoticePopup;
